import { Badge, Container, Stack, Typography } from '@chronosphereio/chrono-ui';
import { memo } from 'react';
import { VariableValue } from '@/core';
import { PanelGroupBadges } from '../PanelGroupBadges';

interface GridTitleProps {
  title?: string;
  isOpen: boolean;
  collapsedText: string;
  isMainPanelGroup?: boolean;
  isSplitPanels?: boolean;
  splitVariableName?: string;
  splitVariableValue?: VariableValue;
}

/**
 * Renders the title for a Grid section, supports expanding and collapsing.
 * Check against split options to determine whether to show badges and disable/hide actions.
 */
export const GridTitle = memo(function GridTitleContent(props: GridTitleProps) {
  const {
    title,
    isOpen,
    collapsedText,
    isMainPanelGroup = true,
    splitVariableValue,
    splitVariableName,
    isSplitPanels = false,
  } = props;

  return (
    <Container.Header data-testid="panel-group-header">
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="h3">{title}</Typography>
        {!isOpen && <Typography variant="body2">{collapsedText}</Typography>}
        {splitVariableName && (
          <PanelGroupBadges
            isMainPanelGroup={isMainPanelGroup}
            splitVariableName={splitVariableName}
            splitVariableValue={splitVariableValue}
          />
        )}
        {isSplitPanels && (
          <Badge
            label={splitVariableName ? `Split panels by $${splitVariableName}` : `Split panels`}
            variant="info"
            size="small"
            TooltipContent={`This is a panel group generated to create Split panels for $${splitVariableName} variable.`}
          />
        )}
      </Stack>
    </Container.Header>
  );
});
